import { createSlice } from "@reduxjs/toolkit";
import { ModalKey } from "../ModalKey.enum";

const initialState = {
  modals: {
    [ModalKey.MOVE_FOLDER]: {
      open: false,
      props: null,
    },
  },
  gallery: {
    folders: [],
    selectedFolder: null,
    folder_page: 1,
    folder_total_pages: 0,
  },
};

const galleryPopup = createSlice({
  name: "galleryPopup",
  initialState,
  reducers: {
    openDialog: (state, action) => {
      const { key, props } = action.payload;
      state.modals[key] = { open: true, props };
    },
    closeDialog: (state, action) => {
      const { key } = action.payload;
      state.modals[key] = { open: false, props: null };
    },

    addItemsToFolder: (state, action) => {
      let { data, parentId } = action.payload || {};
      const parentFolder = findFolderByIdRecursive(
        state.gallery.folders,
        parentId
      );
      if (parentFolder) {
        data.forEach((item) => {
          let alreadyExists = parentFolder.items.find(
            (folderItem) => folderItem.id === item.id
          );
          if (!alreadyExists) {
            parentFolder.items.push(item);
          }
        });
      }
      state.gallery.folders = updateFoldersRecursive(
        state.gallery.folders,
        parentFolder
      );
    },

    addFolders: (state, action) => {
      state.gallery.folders = action.payload.folders;
      state.gallery.folder_page = action.payload.page;
      state.gallery.folder_total_pages = action.payload.total_pages;
    },

    clearGalleryPopup: (state) => {
      state.gallery = initialState.gallery;
      state.modals = initialState.modals;
    },
  },
});

const findFolderByIdRecursive = (folders, folderId) => {
  for (const folder of folders) {
    if (folder.id === folderId) {
      return folder;
    } else if (folder.items && folder.items.length > 0) {
      const nestedFolder = findFolderByIdRecursive(folder.items, folderId);
      if (nestedFolder) {
        return nestedFolder;
      }
    }
  }
  return null;
};

const updateFoldersRecursive = (folders, parentFolder) => {
  return folders.map((folder) => {
    if (folder?.id === parentFolder?.id) {
      return parentFolder;
    } else if (folder.items && folder.items.length > 0) {
      return {
        ...folder,
        items: updateFoldersRecursive(folder.items, parentFolder),
      };
    }
    return folder;
  });
};

export const {
  openDialog,
  closeDialog,
  addItemsToFolder,
  addFolders,
  clearGalleryPopup,
} = galleryPopup.actions;
export default galleryPopup.reducer;

// export const selectIsModalOpen = (modalId) => (state) =>
//   !!state.modal.modals[modalId];
// export const selectAllModalsState = (state) => state.modal.modals;
export const dialog = (key) => (state) => state.galleryPopup.modals[key];
export const selectFolders = (state) => state.galleryPopup.gallery.folders;
export const selectFolderPage = (state) =>
  state.galleryPopup.gallery.folder_page;
export const selectFolderTotalPages = (state) =>
  state.galleryPopup.gallery.folder_total_pages;
export const selectSelectedFolder = (state) =>
  state.galleryPopup.gallery.selectedFolder;
